import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TwilioPostCallAvailabilityType } from './types';
import { request } from './request';
import query from '../../constants/queries';

const usePostCallAvailability = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data: TwilioPostCallAvailabilityType) => request('post', 'twilio/call-availability', data),
        onSuccess: async () =>
            Promise.all([
                queryClient.invalidateQueries({ queryKey: [query.answeringCall] }),
                queryClient.invalidateQueries({ queryKey: [query.userProfile] })
            ])
    });
};
export default usePostCallAvailability;
